@import "styles/variables";

.searchfield {
  position: relative;
  width: 100%;
}

.searchfield--visible {
  display: block;
}

.searchfield--hidden {
  display: none;
}

.search-results {
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  box-shadow: 0 0 3px rgba(0,0,0,.25);
  line-height: 2.2em;
  font-family: var(--font-stack-default);
  font-size: var(--font-size-small);
  letter-spacing: .5px;
  z-index: 11;
  max-height: 400px;
  overflow-y: scroll;
  width: 100%;
}
.search-results li {
  padding: 10px;
  border-bottom: 1px solid var(--color-light-grey-transparent);
}
.search-results a {
  position: relative;
  color: black;
  text-decoration: none;
  display: flex;
  cursor: pointer;
  gap: 10px;
  align-items: center;
}
.search-results a:focus {
  text-decoration: underline;
  outline: none;
}
.activity-indicator {
  width: 100%;
  height: 50px;

  display: flex;
  justify-content: center;
  align-items: center;
}
.search-results li:last-of-type {
  border: none;
}
.result-item {
  line-height: 1rem;
}
.title {
  font-weight: bold;
}
.subtitle {
  font-size: 12px;
}
.search-results .no-matches {
  display: inline-block;
  padding: 7px;
  font-size: var(--font-size-extra-small);
  line-height: 1.4em;
}

.search-inputs {
  width: 100%;
  position: relative;
  display: flex;
}

.redirect-message {
  width: 100%;
  float: right;
  font-family: var(--font-stack-default);
  font-size: 11px;
  margin-top: 0.5em;
}
